export const EXPECTED_ERRORS: {[key: string]: string} = {
  'Workers not ready': 'Alloy is warming its workers. This is expected during deploys and should resolve shortly.',
}
